export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=25ad11e6&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/index.vue?vue&type=template&id=25ad11e6&
// module id = 1315
// module chunks = 0